import { render, staticRenderFns } from "./PrintTournamentGraphs.vue?vue&type=template&id=73065da4&scoped=true"
import script from "./PrintTournamentGraphs.vue?vue&type=script&lang=js"
export * from "./PrintTournamentGraphs.vue?vue&type=script&lang=js"
import style0 from "./PrintTournamentGraphs.vue?vue&type=style&index=0&id=73065da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73065da4",
  null
  
)

export default component.exports